import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useState, useRef } from "react";
import PropTypes from "prop-types";
import { Flex } from "@base-ui";
import { MinifiedSelectButton, MinifiedOptions, styledSystemKeys } from "./minifiedSelect.styles";
import { Label, Option, OptionText } from "./select.styles";
import { useOpen, useClickOutside } from "hooks";
import handleKeyDown from "./handleKeyDown";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MinifiedSelect = function MinifiedSelect(props) {
  var _options$selected;
  var id = props.id,
    label = props.label,
    icon = props.icon,
    flow = props.flow,
    options = props.options,
    onChange = props.onChange,
    inverted = props.inverted,
    className = props.className;
  var _useState = useState(-1),
    _useState2 = _slicedToArray(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  var _useOpen = useOpen(false),
    open = _useOpen.open,
    setOpen = _useOpen.setOpen,
    toggleOpen = _useOpen.toggleOpen;
  var selectRef = useRef();
  var containerRef = useRef();
  var optionsRef = useRef();
  var clickSelect = function clickSelect(idx) {
    onChange(idx);
    setSelected(-1);
    setOpen(false);
  };
  handleKeyDown(id, containerRef, selectRef, optionsRef, open, setOpen, selected, setSelected, options.length - 1);
  useClickOutside(containerRef, function () {
    return setOpen(false);
  }, open);
  var optionsMarkup = options.map(function (option, idx) {
    return /*#__PURE__*/_jsx(Option, {
      id: "".concat(id, "-option-").concat(idx),
      title: option.label,
      "aria-selected": selected === idx,
      selected: selected === idx,
      role: "option",
      onClick: function onClick() {
        return clickSelect(idx);
      },
      children: /*#__PURE__*/_jsx(OptionText, {
        children: option.label
      })
    }, option.id);
  });
  return /*#__PURE__*/_jsxs(Flex.Column, {
    width: "44px",
    className: className,
    children: [/*#__PURE__*/_jsx(Label, {
      id: "".concat(id, "-label"),
      hideLabel: true,
      children: label
    }), /*#__PURE__*/_jsxs(Flex.Column, {
      style: {
        position: "relative"
      },
      ref: containerRef,
      children: [/*#__PURE__*/_jsx(MinifiedSelectButton, {
        id: id,
        icon: icon,
        "aria-haspopup": "listbox",
        "aria-expanded": open,
        "aria-controls": "".concat(id, "-listbox"),
        "aria-labelledby": "".concat(id, "-label ").concat(id),
        open: open,
        flow: flow,
        ref: selectRef,
        inverted: inverted,
        title: (_options$selected = options[selected]) === null || _options$selected === void 0 ? void 0 : _options$selected.label,
        onClick: toggleOpen
      }), /*#__PURE__*/_jsx(MinifiedOptions, _objectSpread(_objectSpread({
        id: "".concat(id, "-listbox"),
        role: "listbox",
        "aria-labelledby": "".concat(id, "-label"),
        "aria-activedescendant": "".concat(id, "-option-").concat(selected),
        ref: optionsRef,
        tabIndex: -1,
        width: "250px",
        left: flow === "right" ? "0" : "auto"
      }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
        open: open,
        children: optionsMarkup
      }))]
    })]
  });
};
MinifiedSelect.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  flow: PropTypes.string,
  inverted: PropTypes.bool,
  className: PropTypes.string
};
MinifiedSelect.defaultProps = {
  flow: "right"
};
export default MinifiedSelect;